import { css } from 'styled-components';

import theme from '../../../../styles/userflow';

export const InputStyles = {
  Base: css`
    font-family: inherit;
    box-sizing: border-box;
    padding: 16px 8px;
    font-size: 14px;
    font-weight: bold;
    line-height: 16px;
    height: 48px;
    transition: background-color 300ms, border-color 300ms;
    border: none;
    background-color: transparent;
  `,
  Normal: css`
    background-color: #fff;
    border: 1px solid ${theme.colors.whiteLight};
    border-radius: 4px;
  `,
  Error: css`
    border: 1px solid #d0021b; //здесь не воспринимает цвета через theme почему-то
    background-color: #f9eaec;
  `,
  Disabled: css`
    background-color: transparent;
  `,
  Placeholder: css`
    font-weight: normal;
    color: ${theme.colors.frenchGray};
  `,
  Focus: css`
    outline: none;
  `,
  Small: css`
    height: 40px;
  `,
};
